import { render, staticRenderFns } from "./noticelist.vue?vue&type=template&id=49477e1a&scoped=true&"
import script from "./noticelist.vue?vue&type=script&lang=js&"
export * from "./noticelist.vue?vue&type=script&lang=js&"
import style0 from "./noticelist.vue?vue&type=style&index=0&id=49477e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49477e1a",
  null
  
)

export default component.exports